/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, ActionButton } from '@components/atoms'
import { FlieDropzone } from '@components/molecules'
import Cropper, { ReactCropperElement } from 'react-cropper'

import { grey, blue } from '@mui/material/colors'
import 'cropperjs/dist/cropper.css'

interface PropsType {
	onGetImage?: (aFile: File) => void
}

export const ImageUplodader = (props: PropsType) => {
	const [showOpenFileBrowser, setShowOpenFileBrowser] = React.useState<boolean>(false)
	const [stateFile, setStateFile] = React.useState<File | null>(null)
	const [image, setImage] = React.useState('')
	// const [croppedImage, setCroppedImage] = React.useState('#')

	const cropperRef = React.createRef<ReactCropperElement>()

	const onFileChange = (aFile: File) => {
		setStateFile(aFile)

		const reader = new FileReader()
		reader.addEventListener('load', () => setImage(reader.result?.toString() || ''))

		reader.readAsDataURL(aFile)
	}

	const getCropData = () => {
		if (typeof cropperRef.current?.cropper !== 'undefined' && stateFile !== null) {
			// const base64String = cropperRef.current?.cropper.getCroppedCanvas().toDataURL()
			// setCroppedImage(base64String)

			if (typeof props.onGetImage === 'function') {
				props.onGetImage(stateFile)
			}
		}
	}

	const onCloseDropzone = () => {
		setShowOpenFileBrowser(false)
	}

	const onDeleteImage = () => {
		setImage('')
		setStateFile(null)
	}

	return (
		<View css={style}>
			{image ? (
				<View className="imageCropperOuterView">
					<View className="imageCropperView">
						<Cropper
							ref={cropperRef}
							style={{ height: 400, width: '100%' }}
							zoomTo={0.5}
							initialAspectRatio={1}
							aspectRatio={1}
							preview=".img-preview"
							src={image}
							viewMode={1}
							minCropBoxHeight={10}
							minCropBoxWidth={10}
							background={false}
							responsive={true}
							autoCropArea={1}
							checkOrientation={false}
							guides={true}
						/>
					</View>

					<View className="imageCropperToolBarView">
						<ActionButton
							tooltip="이미지 삭제"
							title="이미지 삭제"
							onClick={onDeleteImage}
							iconName="close-thick"
							style={{ background: grey[300] }}
							iconTextColor={grey[700]}
						/>
						<ActionButton
							tooltip="저장"
							title="저장"
							onClick={getCropData}
							iconName="check-bold"
							buttonColor="primary"
							style={{ background: blue['A400'], color: 'white' }}
							iconTextColor={'white'}
						/>
					</View>
				</View>
			) : (
				<FlieDropzone
					onFileChange={onFileChange}
					onFileDropEnd={onCloseDropzone}
					showOpenFileBrowser={showOpenFileBrowser}
					onCloseFileBrowser={onCloseDropzone}
					accept={{
						'image/jpeg': ['.jpeg', '.jpg'],
						'image/png': ['.png'],
						'image/bmp': ['.bmp'],
						'image/gif': ['.gif'],
					}}
				></FlieDropzone>
			)}

			{/* <button style={{ float: 'right' }} onClick={getCropData}>
				Crop Image
			</button> */}
		</View>
	)
}

const style = css({
	fontFamily: 'sans-serif',
	padding: '16px',

	'.imageCropperToolBarView': {
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
		marginTop: '0.5rem',
	},
})
